export function calculateDNILetter(dni: number): string 
{
    const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
  
    const remainder = dni % 23;
    const letter = letters.charAt(remainder);
  
    return letter;
  }
  